import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import { useRouteNode } from 'react-router5';
import {useDispatch, useSelector} from "react-redux";
import ContactsTrending from './contact_trending';
import EntitiesTrending from './entities_trending';
import ThemesTrending from './themes_trending';
import PostsTrending from './posts_trending';
import './style/trending.css';
import { FilterDays, FilterContainer } from '../components/filter/filter';
import {useTranslation} from "react-i18next";

import {getTrendingAll} from '../api';
import {getTrending} from "../redux/tendances/tendanceSlice";

function Trending({ portal_ref }) {
  const { t } = useTranslation();

  const { route: {data} } = useRouteNode('profile');

  const [trending_filter, setTrendingFilter] = useState(null);
  const [dataTrending, setDataTrending] =  useState([]);

  const filter_days = useSelector((state) => state.tendance.value);
  const dispatch = useDispatch();

  function setDuration(number) {
    dispatch(getTrending(number));
  };

  function setPostTrending(category, id) {
    setTrendingFilter({category, id})
  }

  useEffect(() => {
    getTrendingAll(filter_days).then(setDataTrending);
  }, [filter_days])


  let view;
  if (trending_filter) {
    view = <PostsTrending key={trending_filter.id + "_" + trending_filter.category}
                          id={trending_filter.id} category={trending_filter.category} number={filter_days}
                          users={data.users} bookmarks={data.bookmarks} />
  } else {
    view = <p className="select_type">{t('Sélectionner un contact, une entité ou un thème')}</p>
  }

  return (
    <>
      { portal_ref.current && ReactDOM.createPortal(
        <FilterContainer>
          <FilterDays value={filter_days} set={setDuration} />
        </FilterContainer>,
        portal_ref.current)
      }

      <div className="c-container_global">
        <section className="c-container_one">
          <div className="c-container_contacts-entities">
            <ContactsTrending contacts={dataTrending.length === 0 ? [] : dataTrending.contact} root={"trending"}
                              setPostTrending={(id) => setPostTrending("contact", id)} />

            <EntitiesTrending entities={dataTrending.length === 0 ? []: dataTrending.entity} root={"trending"}
                              setPostTrending={(id) => setPostTrending("entity", id)} />
          </div>
          <div className="c-trending_themes">
            <ThemesTrending themes={dataTrending.length === 0 ? [] : dataTrending.theme} root={"trending"}
                            setPostTrending={(id) => setPostTrending("theme", id)} />
          </div>
        </section>
        <section className="c-container_two">
          { view }
        </section>
      </div>
    </>
  )
}


export default Trending
